import { render, staticRenderFns } from "./AddClockPanel.vue?vue&type=template&id=13f8c76e&scoped=true&"
import script from "./AddClockPanel.vue?vue&type=script&lang=js&"
export * from "./AddClockPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f8c76e",
  null
  
)

export default component.exports